// src/constants/accuracyLevels.js
export const ACCURACY_LEVELS = Object.freeze({
    STANDARD: "standard",
    ADVANCED: "advanced",
    ENHANCED: "enhanced",
  });
  
  export const ACCURACY_LEVEL_OPTIONS = [
    { value: ACCURACY_LEVELS.STANDARD, label: "Standard LLM" },
    { value: ACCURACY_LEVELS.ADVANCED, label: "Advanced LLM" },
    { value: ACCURACY_LEVELS.ENHANCED, label: "Enhanced (LLM + RAG)" },    
  ];
  